module.exports = __webpack_public_path__ + "static/media/2022-may-image-3.238a7be0.png";